<template>
  <span class="share">
    <span class="share-btn" @click="handleShow">
      <icon type="iconic_share1"></icon>分享
    </span>

    <wechat-share
      class="share-modal"
      ref="wechatShare"
      :shareUrl="shareUrl"
    ></wechat-share>
  </span>
</template>

<script>
import WechatShare from '@/components/wechat-share';

export default {
  components: {
    WechatShare,
  },

  props: {
    shareUrl: String,
  },

  methods: {
    handleShow() {
      this.$refs.wechatShare.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.share {
  &-btn {
    @include btn-style();
  }

  &-modal {
    cursor: default;
  }
}
</style>